export const IS_DEV = window.location.hostname === 'localhost' || window.location.hostname.startsWith('html.dev');
export const TEMPLATE_PATH = IS_DEV ? 'https://badenspa.dev.consult-info.ru' : 'https://xn--80aabnf2cop.online';
